import { render, staticRenderFns } from "./Douyin.vue?vue&type=template&id=baa0b8f2&"
import script from "./Douyin.vue?vue&type=script&lang=js&"
export * from "./Douyin.vue?vue&type=script&lang=js&"
import style0 from "./Douyin.vue?vue&type=style&index=0&id=baa0b8f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports